// @flow
import HomeView from 'Views/home/HomeView.jsx';

export default HomeView;
